import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {AbstractSliderQuestionType} from 'shared/models/questions/abstract-slider-question-type';
import {Question} from 'shared/models/questions/question';
import {QuestionType} from 'shared/models/questions/question-type';
import {TranslatedText} from 'shared/models/translated-text';
import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {QuestionsDetailsService} from './services/questions-details.service';

@Component({
  selector: 'questions-details',
  templateUrl: './questions-details.component.html',
  styleUrls: ['./questions-details.component.css'],
})
export class QuestionsDetailsComponent implements OnInit {

  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public question: Question = {
    title: TranslatedText.createEmptyInstance(),
    description: TranslatedText.createEmptyInstance(),
    type: <QuestionType> {name: '', prettyName: ''},
    inChains: [],
    isSystemQuestion: false,
    keywords: {de: '', en: ''},
  };
  public isChainSystemEditable: boolean;

  public showMarkdownOutput: boolean = false;
  private markdownOutput: {
    de: string,
    en: string,
  };
  private converter: Showdown.Converter = new Showdown.Converter();

  constructor(private questionsDetailsService: QuestionsDetailsService,
              private questionTypeFactoryService: QuestionTypeFactoryService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.converter.setFlavor('github')
  }

  public ngOnInit(): void {
    this.markdownOutput = {de: '', en: ''};
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['questionId'];
    })
      .subscribe((questionId: string) => {
        if (questionId) {
          this.getQuestion(questionId);
        }
      });
  }

  public changeType(type: string): void {
    this.question.type = this.questionTypeFactoryService.createQuestionType(type);

    if (this.question.type instanceof AbstractSliderQuestionType) {
      this.question.type.addKeyPoint();
    }
  }

  public onSubmit(): void {
    if (this.question._id) {
      this.updateQuestion();
    } else {
      this.saveQuestion();
    }
  }

  private getQuestion(id: string): void {
    this.questionsDetailsService.getQuestion(id)
      .subscribe((question: Question) => {
        this.question = question;
        // console.log("res %o", (this.question.inChains && this.question.inChains.length > 0) || this.question.isSystemQuestion)
        this.showMarkdownOutput = true;
        this.updateMarkdown();
        if (!question.keywords) {
          question.keywords = TranslatedText.createEmptyInstance();
        }

    });
  }

  private saveQuestion(): void {
    this.questionsDetailsService.saveQuestion(this.question)
      .subscribe((question: Question) => {
        this.router.navigateByUrl('/questions');
      });
  }

  private updateQuestion(): void {
    this.questionsDetailsService.updateQuestion(this.question)
      .subscribe((question: Question) => {
        this.router.navigateByUrl('/questions');
      });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
  }

  public get caption(): string {
    return this.question._id ? 'Frage bearbeiten' : 'Frage erstellen';
  }

  public get submitButtonText(): string {
    return this.question._id ? 'Speichern' : 'Erstellen';
  }

  private isUsed(): boolean {
    if (this.question.inChains && this.question.inChains.length > 0) {
      return true;
    }
    return false;
  }

  private setMarkdownOutput(value: boolean): void {
    this.showMarkdownOutput = value;
  }

  private updateMarkdown(): void {
    this.markdownOutput[this.language] = this.converter.makeHtml(this.question.description[this.language]);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/questions-details.component.ts